import * as React from 'react';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';

import { Message } from './Message';

export const Duplicate: React.FC = () => (
  <Message>
    <div className="flex justify-center">
      <WarningIcon />
    </div>
    <div className="text-2xl mb-4">Duplicate file</div>
    <div>
      This file has already been uploaded, please modify your file and its name to upload it again.
    </div>
  </Message>
);
Duplicate.displayName = 'Duplicate';
